import EntityProperty from '@enums/EntityProperty';
import { PropertyType } from '@/lib/enums';

/**
 * Extends text based entity properties with updated selections.
 */
export default function extendEntityTextProperties({
  entity,
  properties,
  propertyMap,
}) {
  const updatedProperties = [...properties];

  entity[EntityProperty.PROPERTIES]?.forEach((property) => {
    const libraryProperty = propertyMap?.get(property.key);

    if (libraryProperty?.type === PropertyType.TEXT) {
      updatedProperties.push(property);
    }
  });

  return updatedProperties;
}
